module.exports = __webpack_public_path__ + "images/emoji/cake.8c2ff313a69ac8e0ce45.png";